export default {
    apiUrl: "https://aisense.iossco.com/api/public/",
};